import axios from 'axios'
import { Toast } from 'vant'

const requests = axios.create({
  baseURL: '/api',
  timeout: 50000,
})
// 存储每个请求的标识和取消函数
const pendingRequests = new Map()
// 生成请求唯一标识
const generateRequestKey = (config) => {
  const { method, url } = config
  return `${method}&${url}`
}
requests.interceptors.request.use((config) => {
  const cancelDuplicate = config.cancelDuplicate ?? true

  if (cancelDuplicate) {
    const requestKey = generateRequestKey(config)
    
    if (pendingRequests.has(requestKey)) {
      const cancel = pendingRequests.get(requestKey)
      cancel(`重复请求被取消: ${requestKey}`)
      pendingRequests.delete(requestKey)
    }

    config.cancelToken = new axios.CancelToken(cancel => {
      pendingRequests.set(requestKey, cancel)
    })
  }
  const authorization = localStorage.getItem('token')
  if (authorization) {
    config.headers['X-Auth-Token'] = authorization
  }
  return config
})

requests.interceptors.response.use(
  (res) => {
    // 清理请求记录
    const requestKey = generateRequestKey(res.config)
    pendingRequests.delete(requestKey)

    // 检查业务状态码，即使HTTP状态码是200
    if (res.data && typeof res.data.code !== 'undefined' && res.data.code !== 200) {
      // 显示错误信息
      const message = res.data.msg || '业务处理失败，请重试'
      Toast.fail({ message, position: 'top', icon: 'clear' })

      // 对于401错误，执行登录过期逻辑
      if (res.data.code === 401) {
        setTimeout(() => {
          localStorage.removeItem("token")
          localStorage.removeItem("userInfo")
          localStorage.removeItem("addScanText")
          window.location.replace('/login')
        }, 1000)
      }

      // 返回rejected状态的Promise，便于调用者捕获错误
      return Promise.reject(res.data)
    }

    return res.data
  },
  (err) => {
    if (err.code === "ERR_CANCELED") { return [] }
    if (err && err.response && err.response.status !== 200) {
      console.log(err.response.data.msg || err.response.data.msg, 'err.response.data.msg')
      const message = err.response.data.msg || err.response.data.msg || '请求出错，请稍候重试'
      Toast.fail({ message, position: 'top', icon: 'clear' });
    }
    // 后端的接口status只有200和500 token过期信息是在500接口里面的response.data中体现的
    // if (err.response.status === 401) {
    if (err.response && err.response.data.code === 401) {
      const message = err.response.data.msg || err.response.data.msg || '请求出错，请稍候重试'
      Toast.fail({ message, position: 'top', icon: 'clear' });

      setTimeout(() => {
        localStorage.setItem("token", "");
        localStorage.setItem("userInfo", "");
        localStorage.setItem("addScanText ", "");
        window.location.replace('/login')
      })
    }
    if (axios.isCancel(err)) {
      return Promise.reject({ isCanceled: true })
    }
    const requestKey = generateRequestKey(err.config)
    pendingRequests.delete(requestKey)
    return Promise.reject(err)
  }
)

export default requests
